/**
 * @copyright Copyright © 2020-2025 Airbus DS SLC. All rights reserved.
 * @description Global container for the Dispatcher application.
 */

import {Application} from "@airbus/library-application";

/**
 * Globals container for the Dispatcher application.
 */
export class Dispatcher extends Application {
    /**
     * Create a new Dispatcher instance.
     * @param {string} name - The name of the Dispatcher application.
     */
    constructor(name) {
        super(name);
        /**
         * Version of the dispatcher application.
         * @type {Array}
         */
        // @ts-ignore
        this.version = __APP_VERSION__;
        /**
         * Indicates if global debugging functions are enabled.
         * @type {string}
         */
        // @ts-ignore
        this.debug = __DEBUG__;
    }
}

/**
 * The global dispatcher object.
 * @type {Dispatcher}
 */
export const dispatcher = new Dispatcher("airbusDispatcher");

dispatcher.bootstrap.register_module({
    name: "global",
    deps: ["application"],
    /**
     * Initialize the global module.
     * @async
     * @returns {Promise<void>}
     */
    init: async () => {
        dispatcher.vue_app.use({
            /**
             * Install the dispatcher as a global property.
             * @param {import("vue").App} app - The Vue application instance.
             */
            install: (app) => {
                app.config.globalProperties.$dispatcher = dispatcher;
            }
        });
    }
});
